import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';

export default class WatchlistService extends Singleton<WatchlistService> {
  /**
   * Public Methods
   */
  public addToWatchlist = async (tradeId: number) => {
    if (!tradeId) {
      return;
    }

    const client = await ApiService();

    await client.apis.list.addToList({
      id: 'watchlist',
      request: {
        tradeId
      }
    });
  };

  public removeFromWatchlist = async (tradeId: number) => {
    if (!tradeId) {
      return;
    }

    const client = await ApiService();

    await client.apis.list.removeFromList({
      id: 'watchlist',
      request: {
        tradeId
      }
    });
  };
}
